import { z } from 'zod';

import {
  ErrorClassSchema,
  PlatformComponentSchema,
} from './platform-component';

export const TimeBasedPlatformStatusSchema = z.object({
  activeErrorClass: ErrorClassSchema.optional(),
  platformComponents: z.array(PlatformComponentSchema),
});

export type TimeBasedPlatformStatus = z.infer<
  typeof TimeBasedPlatformStatusSchema
>;
